import { guard, reduce, transition } from "robot3";

import { BUDGET_GAME_STATES } from "./constants";
import {
  calculateNewSlideIndex,
  isNavigatingToFirstSlide,
  isNavigatingToLastSlide,
} from "./guards";
import {
  navigateReducer,
  optionAddedReducer,
  planCreationFailedReducer,
  regionalTaxRateChangedReducer,
  slideChangedReducer,
  startOverReducer,
} from "./reducers";

export const dataLoadedTransition = (to) =>
  transition(
    "dataLoaded",
    to,
    reduce((ctx, { property, data }) => ({
      ...ctx,
      [`${property}Loaded`]: true,
      [property]: data,
    })),
  );

export const slideChangedTransition = transition(
  "slideChanged",
  BUDGET_GAME_STATES.budgeting,
  guard((ctx, { slideIndex }) => ctx.currentSlideIndex !== slideIndex),
  slideChangedReducer,
);

export const calculatorCompletedTransition = transition(
  "calculatorCompleted",
  BUDGET_GAME_STATES.calculator,
  reduce((ctx) => ({
    ...ctx,
    isTakeHomePayCalculated: true,
  })),
);

export const optionAddedTransition = (to = BUDGET_GAME_STATES.budgeting) =>
  transition("optionAdded", to, optionAddedReducer);

export const regionalTaxRateChangedTransition = transition(
  "regionalTaxRateChanged",
  BUDGET_GAME_STATES.calculator,
  regionalTaxRateChangedReducer,
);

export const startOverTransition = transition(
  "startOver",
  BUDGET_GAME_STATES.initializing,
  startOverReducer,
);

export const planCreationFailedTransition = transition(
  "planCreationFailed",
  BUDGET_GAME_STATES.planCreationFailed,
  planCreationFailedReducer,
);

export const navigateToCalculatorTransition = transition(
  "navigate",
  BUDGET_GAME_STATES.calculator,
  guard(isNavigatingToFirstSlide),
  navigateReducer,
);

export const navigateToCompleteTransition = transition(
  "navigate",
  BUDGET_GAME_STATES.complete,
  guard(isNavigatingToLastSlide),
  navigateReducer,
);

export const navigateBudgetingTransition = transition(
  "navigate",
  BUDGET_GAME_STATES.budgeting,
  guard((ctx, event) => {
    const newIndex = calculateNewSlideIndex(ctx, event);
    return newIndex > 0 && newIndex < ctx.totalSlides;
  }),
  navigateReducer,
);
